angular.module('impactx.basket').controller('BasketAttributesCtrl', BasketAttributesCtrl);

BasketAttributesCtrl.$inject = ['$scope', 'dataGen', 'TranslationService', '$mdDialog', 'bkiId', 'themeFactory'];

function BasketAttributesCtrl($scope, dataGen, TranslationService, $mdDialog, bkiId, themeFactory) {
    $scope.theme = themeFactory.getTheme();
    var ctrl = this;
    $scope.errorList = [];

    ctrl.getData = function () {
        var paramObj = {
            bkiId: bkiId
        };
        dataGen.getData($scope, paramObj, '/basket/variableattributes/get').then(function () {
            $scope.trns.save = TranslationService.get('save');
            $scope.trns.required = TranslationService.get('required');
        })
    };

    ctrl.saveAttributes = function () {
        var paramObj = {
            attributesData: $scope.data
        };
        dataGen.postAsForm({}, paramObj, '/basket/variableattributes/save').then(function () {
            $mdDialog.hide();
        });
    };

    ctrl.getData();
}